export enum DocumentStatesEnum {
  VALIDATED = 'aimed',
  DELAYED = 'delayed',
  WAITING = 'waiting',
  WITHOUT_VALIDATION = 'without_validation',
}
